<template>
    <page>
        <module enable-flex>
            <view-list ref="view" :work-type="35">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="商户">
                            <c-select name="merchant_id" async @search="searchMerchant"></c-select>
                        </m-search-item>
                        <m-search-item label="商户名称">
                            <c-input name="merchant_name" placeholder="支持模糊查询"></c-input>
                        </m-search-item>
                        <m-search-item label="发货单号">
                            <c-input name="delivery_no"></c-input>
                        </m-search-item>
                        <m-search-item label="收货人">
                            <c-input name="receiver_name"></c-input>
                        </m-search-item>
                        <m-search-item label="收货人手机">
                            <c-input name="receiver_phone"></c-input>
                        </m-search-item>
                        <m-search-item label="订单号">
                            <c-input name="order_no"></c-input>
                        </m-search-item>
                        <m-search-item label="快递单号">
                            <c-input name="express_no"></c-input>
                        </m-search-item>
                        <m-search-item label="快递公司">
                            <c-input name="express_company_code" placeholder="支持模糊查询"></c-input>
                        </m-search-item>
                        <m-search-item label="创建时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <c-table-column type="button" label="操作" width="80" fixed="right">
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="$refs.detail.open(data)">详情</c-table-button>
                    </template>
                </c-table-column>

                <template #saas_info="{data}">
                    <div class="m-saas-info">
                        <p>{{data.saas_id || '-'}}</p>
                        <p class="m-saas-info-name">{{data.saas_name || '-'}}</p>
                    </div>
                </template>

                <template #receiver_name="{data}">
                    <div v-if="data.receiver_name || data.receiver_phone">
                        <p>{{data.receiver_name || '-'}} {{data.receiver_phone ? '(' + data.receiver_phone + ')' : ''}}</p>
                    </div>
                    <span v-else>-</span>
                </template>

                <template #ship_qty="{data}">
                    {{data.all_qty || data.ship_qty}}
                </template>

                <template #ship_state="{data}">
                    <span v-if="data.delivery_result" :class="deliveryResultClass(data.delivery_result)">{{deliveryResultText(data.delivery_result)}}</span>
                    <c-state v-else async dict="DELIVERY_STATE" :value="data.ship_state"></c-state>
                </template>

                <template #create_date="{data}">
                    {{data.create_date || '-'}}
                </template>

                <template #order_no="{data}">
                    <div v-if="data.order_no" class="erp-delivery-orders">
                        <p v-for="(orderNo, index) in String(data.order_no).split(',')" :key="index">{{orderNo}}</p>
                    </div>
                    <span v-else>-</span>
                </template>
            </view-list>
            <erp-delivery-detail ref="detail"></erp-delivery-detail>
        </module>
    </page>
</template>

<script>
import ErpDeliveryDetail from './components/delivery_detail.vue';

export default {
    name: 'erp_delivery',
    components: {ErpDeliveryDetail},
    methods: {
        searchMerchant(keyword, resolve) {
            this.request({url: '/sys_saas/options', data: {keyword}, success: resolve});
        },
        deliveryResultText(result) {
            return {1: '已发货（全部成功）', 2: '已发货（部分成功）', 3: '已关闭（全部失败）'}[result] || '待发货';
        },
        deliveryResultClass(result) {
            return {1: 'm-ship-success', 2: 'm-ship-partial', 3: 'm-ship-fail'}[result] || '';
        }
    }
};
</script>

<style scoped>
.erp-delivery-orders p {margin: 0; line-height: 20px;}
.m-ship-success {color: #52c41a;}
.m-ship-partial {color: #fa8c16;}
.m-ship-fail {color: #ed3f14;}
.m-saas-info {line-height: 20px; font-size: 13px; color: #333;}
.m-saas-info p {margin: 0;}
.m-saas-info-name {color: #999; font-size: 12px;}
</style>
